<template>
  <v-container
    grid-list-xs
    fluid
    class="pa-2 pt-0 pb-0"
  >
    <v-container
      v-if="anytimeConsultations"
      grid-list-xs
      fluid
      class="pa-2 pt-0 pb-0"
    >
      <v-card
        :flat="true"
        class="anytime-consultation-search-info pl-2 pt-2"
      >
        <v-card-text class="row pa-0 d-flex flex-row">
          {{ order }}に表示 / {{ anytimeConsultations.length }}件ヒット
          <span
            v-if="incompleted"
            class="ml-auto"
          >
            <v-switch
              v-model="filtered"
              base-color="grey-lighten-1"
              color="blue-accent-1"
              hide-details
              :flat="true"
              label="担当分を表示"
              class="ma-0 filtered-toggle"
              :class="anytimeConsultationFilteredFlag? 'filtered' : 'unfiltered'"
              @change="switchFilteredFlag"
            />
          </span>
        </v-card-text>
      </v-card>
      <v-container fluid>
        <div
          v-for="consultation in anytimeConsultations"
          :key="consultation.id"
          class="anytime-consultation-info"
          :class="showIncentiveNotice(consultation) ? 'over-deadline-incentive' : ''"
        >
          <div
            v-if="showIncentiveNotice(consultation)"
            class="incentive-notice ma-2"
          >
            <v-icon
              class="notice-icon"
              color="white"
              size="30px"
            >
              mdi-alert-circle-outline
            </v-icon>
            他の相談員が期限内に回答できませんでした。代わりに回答をお願いいたします。インセンティブをお支払いします。
          </div>
          <anytimeConsultationDetail
            :anytime-consultation="consultation"
            :tab-id="tabId"
            :incentive="showIncentiveNotice(consultation)"
            :show-countdown="incompleted"
            :now-ms="nowMs"
          />
        </div>

        <!-- 担当分を表示 -->
        <!-- 未回答 -->
        <!-- 担当科目 -->
        <div v-if="anytimeConsultationFilteredFlag && incompleted && currentDepartmentType">
          <!-- 受付時間中 -->
          <div v-if="onShift">
            <anytimeConsultationAnswerNotice
              bg-color="#F9E5EC"
              text-color="#E00051"
              icon="mdi-alert-circle-outline"
              title="受付時間中"
              detail="相談が増える可能性があります。"
            />
          </div>
          <!-- 受付終了 -->
          <div v-else-if="anytimeConsultations.length > 0">
            <anytimeConsultationAnswerNotice
              bg-color="#D7D7D7"
              text-color="#8A8A8A"
              icon="mdi-bell-outline"
              title="受付終了"
              detail="これ以上相談は増えません。"
            />
          </div>
          <!-- 勤務完了 -->
          <!-- consultationsLoadedがtrueの場合のみ表示。つまり相談データ取得後に表示する -->
          <!-- これにより部門切り替え時に相談読込前に「勤務完了」が表示される競合状態を防ぐ -->
          <div v-else-if="noticeExpiration && consultationsLoaded === true">
            <anytimeConsultationAnswerNotice
              bg-color="#ECF7E4"
              text-color="#69B72E"
              icon="mdi-emoticon-happy-outline"
              title="勤務完了"
              detail="ご担当ありがとうございました。"
            />
          </div>
        </div>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AnytimeConsultationDetail from "./shared/AnytimeConsultationDetailCard.vue";
import AnytimeConsultationAnswerNotice from "./shared/ac_shift/AnytimeConsultationAnswerNotice.vue";

const COUNTDOWN_INTERVAL_MS = 60 * 1000;
const DEPARTMENT_TYPES = {
  "1": "pediatrician",
  "2": "obstetrician",
  "3": "midwife",
};

export default {
  name: "AnytimeConsultationList",
  components: {
    AnytimeConsultationDetail,
    AnytimeConsultationAnswerNotice
  },
  data: () => ({
    tabId: 0,
    order: "古い順",
    incompleted: true,
    departmentType: null,
    filtered: true,
    nowMs: Date.now(),
    countdownTimerId: null,
    departmentTypes: DEPARTMENT_TYPES,
    currentDepartmentType: false,
    consultationsLoaded: null,  // 現在の部門の相談読込完了フラグ
  }),
  computed: {
    ...mapGetters([
      "anytimeConsultations",
      "currentDoctor",
      "anytimeConsultationFilteredFlag",
      "onShift",
      "noticeExpiration",
      "hasAllCapabilities"
    ]),
    counselorDoctor: function () {
      return this.hasAllCapabilities(["counselor:access"]);
    },
    operatorDoctor: function () {
      return this.hasAllCapabilities(["operator:access"]);
    },
  },
  methods: {
    ...mapActions([
      "fetchAnytimeConsultations",
      "fetchAssignedAnytimeConsultations",
      "fetchCompletedAnytimeConsultations",
      "assignFilteredFlag",
      "fetchCurrentDoctor",
      "isOnAnytimeConsultationShift",
      "isAnswerNoticeExpiration"
    ]),
    loadList: function () {
      this.incompleted = this.$route.query.complete == 0 ? true : false;
      this.departmentType = this.$route.query.department;
      this.currentDepartmentType = (this.departmentType in this.departmentTypes && this.departmentTypes[this.departmentType] === this.currentDoctor.department_type);
      if(this.incompleted){
        this.loadIncompletedList();
      } else {
        // 完了済
        this.consultationsLoaded = false;
        this.fetchCompletedAnytimeConsultations({
          department: this.departmentType
        }).then(() => {
          this.consultationsLoaded = true;
        });
        this.order = "新しい順";
      }
      this.tabId = this.$route.query.tab_id;
    },
    loadIncompletedList: function() {
      // 未完了
      // 新しい部門の相談ロード開始時、フラグをリセット
      this.consultationsLoaded = false;
      
      if((this.counselorDoctor || this.operatorDoctor ) && this.filtered){
        // アサインされた相談のみ
        this.fetchAssignedAnytimeConsultations({
          department: this.departmentType
        }).then(() => {
          this.consultationsLoaded = true;
        });
      } else {
        // すべての相談
        this.fetchAnytimeConsultations({
          department: this.departmentType
        }).then(() => {
          this.consultationsLoaded = true;
        });
      }
      this.order = "古い順";
    },
    switchFilteredFlag: function() {
      this.assignFilteredFlag(this.filtered);
      this.loadIncompletedList();
    },
    isOnShift: function () {
      this.isOnAnytimeConsultationShift({
        doctor_id: this.currentDoctor.id
      });
    },
    isNoticeExpiration: function () {
      this.isAnswerNoticeExpiration({
        doctor_id: this.currentDoctor.id
      });
    },
    isNoRemainingTime: function (consultation) {
      const deadlineAtIso = consultation?.deadlineAtIso;
      if (!deadlineAtIso) return false;

      const deadlineMs = Date.parse(deadlineAtIso);
      if (Number.isNaN(deadlineMs)) return false;

      const remainingMs = deadlineMs - this.nowMs;
      return remainingMs <= 0;
    },
    showIncentiveNotice: function (consultation) {
      return this.incompleted && this.filtered && (consultation.overDeadline || this.isNoRemainingTime(consultation));
    }
  },
  watch: {
    "$route.query" () {
      this.loadList();
      this.isOnShift();
      this.isNoticeExpiration();
    }
  },
  created() {
    this.fetchCurrentDoctor().then(() => {
      if(this.counselorDoctor || this.operatorDoctor){
        this.filtered = this.anytimeConsultationFilteredFlag;
      } else {
        this.filtered = false;
      }
      this.loadList();
      this.isOnShift();
      this.isNoticeExpiration();
    });
  },
  mounted() {
    this.nowMs = Date.now();
    this.countdownTimerId = setInterval(() => {
      this.nowMs = Date.now();
    }, COUNTDOWN_INTERVAL_MS);
  },
  beforeUnmount() {
    if (this.countdownTimerId) {
      clearInterval(this.countdownTimerId);
      this.countdownTimerId = null;
    }
  },
};
</script>

<style lang="scss">
  .anytime-consultation-search-info {
    background-color: #fafafa;
    margin: 2px;

    .v-card__text {
      background-color: #fafafa;
    }
  }

  .anytime-consultation-info {
    border: solid 1px #888888;
    background-color: white;
    border-radius: 2px;

    .v-card {
      border: solid 1px #bdbdbd !important;
      height: 100%;
    }
  }
  .over-deadline-incentive{
    background-color: #E00051!important;

    div.incentive-notice {
      font-weight: bold;
      font-size: 14px;
      color: white;

      .notice-icon {
        width: 30px;
        height: 30px;
      }
    }
  }
  .filtered {
    label {
      color: #212121 !important;
    }
  }
  .unfiltered {
    label {
      color: #ccc !important;
    }
  }
  .v-switch .v-selection-control {
    min-height: 0px !important;
  }
  .v-switch .v-selection-control--density-default {
    --v-selection-control-size: auto !important;
  }
  .v-switch .v-selection-control > label {
    margin-bottom: 0px !important;
  }
</style>
